import { render, staticRenderFns } from "./role-dept-inspector-edit.vue?vue&type=template&id=8ea72fac&scoped=true"
import script from "./role-dept-inspector-edit.vue?vue&type=script&lang=js"
export * from "./role-dept-inspector-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea72fac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ea72fac')) {
      api.createRecord('8ea72fac', component.options)
    } else {
      api.reload('8ea72fac', component.options)
    }
    module.hot.accept("./role-dept-inspector-edit.vue?vue&type=template&id=8ea72fac&scoped=true", function () {
      api.rerender('8ea72fac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/project-management/role-dept-inspector-edit.vue"
export default component.exports